import state from "@/store/modules/schedule/state";
import actions from "@/store/modules/schedule/actions";
import mutations from "@/store/modules/schedule/mutations";
import getters from "@/store/modules/schedule/getters";

export default {
  state,
  actions,
  mutations,
  getters
}